import React, { useRef } from 'react';
import { bool, number, object } from 'prop-types';
import { generateGuestCheckoutToken, inGuestSkipCheckoutExp } from '../utils';

/**
 * @constant {string}
 * @desc payment funnel source sent to /payments.
 */
const FUNNEL_SOURCE = 'gig_page';

const PaymentFormItems = ({
    quantity,
    duration,
    selectedRecurringOption,
    isRecurringOrderSelected,
    gigId,
    isRisingTalent,
    isFiverrChoice,
    isMilestoneOrder,
    selectedPackageId
}) => {
    const guestCheckoutTokenRef = useRef(generateGuestCheckoutToken());

    return (
        <>
            <input type="hidden" name="quantity" value={quantity}/>
            <input type="hidden" name="package_id" value={selectedPackageId}/>
            <input type="hidden" name="gig_id" value={gigId}/>
            <input type="hidden" name="total_delivery" value={duration}/>
            <input type="hidden" name="milestones_purchase" value={!!isMilestoneOrder}/>
            <input type="hidden" name="fiverr_choice" value={!!isFiverrChoice}/>
            <input type="hidden" name="rising_talent" value={!!isRisingTalent}/>
            <input type="hidden" name="payment_funnel_source" value={FUNNEL_SOURCE}/>
            {!!isRecurringOrderSelected &&
            <input type="hidden" name="recurring_option_id" value={selectedRecurringOption.id}/>
            }
            {inGuestSkipCheckoutExp() &&
            <input type="hidden" name="guest_checkout_token" value={guestCheckoutTokenRef.current}/>
            }
        </>
    );
};

PaymentFormItems.propTypes = {
    quantity: number.isRequired,
    selectedPackageId: number.isRequired,
    gigId: number.isRequired,
    duration: number.isRequired,
    isMilestoneOrder: bool,
    isRisingTalent: bool,
    isFiverrChoice: bool,
    selectedRecurringOption: object,
    isRecurringOrderSelected: bool
};

export default PaymentFormItems;
